import { render } from "./PackagesKids.vue?vue&type=template&id=481d7a32&scoped=true"
import script from "./PackagesKids.vue?vue&type=script&lang=js"
export * from "./PackagesKids.vue?vue&type=script&lang=js"

import "./PackagesKids.vue?vue&type=style&index=0&id=481d7a32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481d7a32"]])

export default __exports__